module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-commercial-4-32624d700d6c05d11be9ebb3d7d2c6fe.png";